// extracted by mini-css-extract-plugin
export default {"timeInput":"ProfileGoalEditComponent_timeInput__22XQ8"};